<template>
  <div>
    <b-card>
      <!-- <b-overlay :show="show" class="d-inline-block" opacity="0" color=""> -->
      <b-card style="overflow: hidden">
        <b-row>
          <!-- <b-col
          md="3"
          class="mb-1"
        >
          <b-input-group>
            <b-form-input placeholder="Фильтр" />
            <b-input-group-append>
              <b-button variant="outline-primary">
                Поиск
              </b-button>
            </b-input-group-append>
          </b-input-group>
        </b-col> -->
          <b-col
            md="8"
            class="d-flex justify-content-end mb-1"
          >
            <b-form-select
              v-model="selected"
              :options="options"
            />

          </b-col>
          <b-col md="2">
            <b-form-datepicker
              id="start"
              v-model="startDate"
              class="mr-1"
              :state="startDate ? true : null"
              locale="en-US"
              :date-format-options="{ year: 'numeric', month: 'numeric', day: 'numeric' }"
              placeholder="От числа"
            />
          </b-col>
          <b-col md="2">
            <b-form-datepicker
              id="end"
              v-model="endDate"
              :state="endDate ? true : null"
              locale="en-US"
              :date-format-options="{ year: 'numeric', month: 'numeric', day: 'numeric' }"
              placeholder="До числа"
            />
          </b-col>
        </b-row>

        <app-table
          responsive="sm"
          :items="items"
          :fields="tableColumns"
          :loading="loading"
          style="width: 100%; overflow: auto"
        >
          <template v-slot:cell(actions)="data">
            <b-button
              v-ripple.400="'rgba(255, 255, 255, 0.15)'"
              variant="primary  "
              class="btn-icon mr-1"
              :to="{ name: 'order', params: { id: data.item.id } }"
            >
              <feather-icon icon="EyeIcon" />
            </b-button>
            <b-button
              v-ripple.400="'rgba(255, 255, 255, 0.15)'"
              variant="primary  "
              class="btn-icon mr-1"
              v-if="data.item.payment_method_id === 1"
              @click="() => log(data.item.payment.id)"
            >
              <b-spinner small v-if="isLoadingPaymentStatus === data.item.payment.id"/>
              <feather-icon v-if="isLoadingPaymentStatus !== data.item.payment.id" icon="RefreshCcwIcon" />
            </b-button>
          </template>

        </app-table>
      </b-card>
      <b-row>
        <b-col>
          <b-pagination-nav
            v-if="numberOfPages > 1"
            :value="currentPage"
            :number-of-pages="numberOfPages"
            :link-gen="pageLink"
            :disabled="loading"
            use-router
            hide-goto-end-buttons
          />
        </b-col>
        <b-col md="3">
          <label
            :style="{ color: activeColor, fontSize: '15px' }"
            for="total"
          >Всего заказов: {{ total }}</label>
        </b-col>
      </b-row>
    </b-card>
  </div>
</template>

<script>
import {
  BButton,
  BCol,
  BModal,
  BRow,
  VBModal,
  BCard,
  BFormSelect,
  BPaginationNav,
  BSpinner,
  BFormDatepicker,
} from 'bootstrap-vue'
import Ripple from 'vue-ripple-directive'
import axios from '@axios'
import { $themeConfig } from '@themeConfig'
import AppTable from '@/components/AppTable.vue'
import routePagination from '@/mixins/routePagination'
import { codeSeparated } from './Pagination/code'

// YYYY-MM-DD date from a URL query value, otherwise null
const toDate = value => (/^\d{4}-\d{2}-\d{2}$/.test(value) ? value : null)

export default {

  components: {
    // eslint-disable-next-line vue/no-unused-components
    VBModal,
    // eslint-disable-next-line vue/no-unused-components
    BModal,
    AppTable,
    BRow,
    BCol,
    BCard,
    BButton,
    BFormSelect,
    BPaginationNav,
    BSpinner,
    BFormDatepicker,
  },
  directives: {
    'b-modal': VBModal,
    Ripple,
  },
  mixins: [routePagination],
  data() {
    return {
      dialogVisible: false,
      tableColumns: [
        { key: 'id', label: '#' },
        { key: 'user.name', label: 'Имя' },
        // { key: 'payment_method_id', label: 'Способ оплата', sortable: true },
        { key: 'shipping_type', label: 'Доставка' },
        { key: 'promo_code', label: 'Промо-код' },
        // { key: 'discount', label: 'Скидка' },
        // { key: 'total', label: 'Итог' },
        { key: 'user.address', label: 'Адрес' },
        { key: 'user.phone', label: 'Телефон' },
        { key: 'status_name', label: 'Статус' },
        {
          key: 'items.length',
          label: 'Кол-товаров',
        },
        {
          key: 'created_at',
          label: 'Дата',
          formatter: value => new Date(value).toLocaleString(),
        },
        { key: 'actions', label: 'Действия' },
      ],
      options: [
        { value: null, text: 'Сортировать' },
        { value: 'new', text: 'Новая заявка' },
        { value: 'reviewing', text: 'В обработке' },
        { value: 'delivering', text: 'Доставка' },
        { value: 'delivered', text: 'Доставка выполнена' },
        { value: 'completed', text: 'Успешно завершено' },
        { value: 'cancelled', text: 'Отмена заявки' },
      ],
      codeSeparated,
      defaultPerPage: 13,
      isLoadingPaymentStatus: null,
    }
  },
  computed: {
    // Filters live in the URL: ?status=...&start_date=...&end_date=...
    selected: {
      get() {
        const { status } = this.$route.query
        return this.options.some(option => option.value && option.value === status) ? status : null
      },
      set(value) {
        this.updateFilters({ status: value })
      },
    },
    startDate: {
      get() {
        return toDate(this.$route.query.start_date)
      },
      set(value) {
        this.updateFilters({ start_date: value })
      },
    },
    endDate: {
      get() {
        return toDate(this.$route.query.end_date)
      },
      set(value) {
        this.updateFilters({ end_date: value })
      },
    },
  },
  methods: {
    async log(id) {
      this.isLoadingPaymentStatus = id
      await this.updatePaymentStatus(id)
    },
    showVisible() {
      this.dialogVisible = true
    },
    // Called by the routePagination mixin
    fetchItems({ page, perPage }) {
      const params = {
        status: this.selected,
        per_page: perPage,
        page,
      }
      // Only "from": up to today; only "to": that single day
      if (this.startDate || this.endDate) {
        params.start_date = this.startDate || this.endDate
        params.end_date = this.endDate || new Date().toISOString().slice(0, 10)
      }
      return axios.get(`${$themeConfig.app.API}v2/admin/orders`, { params })
        .then(res => ({
          items: res.data.data,
          total: res.data.meta.total,
          perPage: res.data.meta.per_page,
        }))
    },
    async getStatuses() {
      await axios.get(`${$themeConfig.app.API}v2/admin/orders/${this.$route.params.id}`)
        .then(res => {
          this.statuses = res.data.data || []
        })
    },
    async updatePaymentStatus(paymentId) {
      try {
        const response = await axios.post(`${$themeConfig.app.API}web/payment/check/${paymentId}`)
        if (response.status === 200) {
          this.isLoadingPaymentStatus = null
          this.$bvToast.toast('Статус оплаты обновлен', {
            title: 'Успешно',
            variant: 'success',
            solid: true,
          })
          this.loadItems()
        }
      } catch (e) {
        this.isLoadingPaymentStatus = null
        this.$bvToast.toast('Ошибка обновления статуса оплаты', {
          title: 'Ошибка',
          variant: 'danger',
          solid: true,
        })
      }
    },
  },
}
</script>
